export default {"src":"/_next/static/media/MarketAnalysisImg.8dfd3c7e.svg","height":1186,"width":1094,"blurWidth":0,"blurHeight":0};